import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  makeStyles,
  useMediaQuery,
  CircularProgress,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Pagination } from "@material-ui/lab";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import moment from "moment";
import { Card, CardActions, CardContent } from "../../components/Card";
import Table from "../../components/Table";
import { useAlert } from "../../components/Alert";
const GET_PERSONALMESSAGES = gql`
  query personalMessages(
    $id: Int
    $type: PersonalMessageType
    $searchTerm: String
    $latest: Boolean
    $status: AssignmentStatus
    $pageSize: Int
    $page: Int
  ) {
    personalMessages(
      id: $id
      type: $type
      searchTerm: $searchTerm
      latest: $latest
      status: $status
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        category {
          id
          name
          createdAt
          updatedAt
        }
        task
        response
        status
        statusUpdatedAt
        expectedFinishedAt
        shouldFinishAt
        finishedAt
        assignTo {
          id
          fullName
        }
        assignedBy {
          id
          fullName
        }
        updatedBy {
          id
          fullName
        }
        createdAt
        updatedAt
      }
    }
  }
`;
export default function AssignmentsOnlyReadTable() {
  const Alert = useAlert();
  const history = useHistory();
  const isPhone = useMediaQuery("(max-width:576px)");
  const [newData, setNewData] = useState({
    addOpen: false,
    replyOpen: false,
    editOpen: false,
    editCategoryOpen: false,
    searchTerm: "",
    statusArray: [
      { label: "待決策", value: "TO_BE_DECIDED" },
      { label: "未進行", value: "PENDING" },
      { label: "進行中", value: "IN_PROGRESS" },
    ],
    statusObject: {},
    data: {},
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });
  const { data, loading } = useQuery(GET_PERSONALMESSAGES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      id: Number(localStorage.getItem("@fullhouseUserId")),
      type: "ASSIGNMENT",
      searchTerm: newData.searchTerm,
      latest: true,
      status: newData.statusObject.value,
      pageSize: 10,
      page: newData.page,
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  function getColor(date, state) {
    let deadline;
    if (!!date) {
      deadline = moment(date).diff(new Date(), "days");
    }

    if (
      state === "PENDING" ||
      state === "TO_BE_DECIDED" ||
      state === "FINISHED"
    ) {
      switch (state) {
        case "TO_BE_DECIDED":
          return "#ff9800";
        case "PENDING":
          return "#ffeb3b";
        case "FINISHED":
          return "#2196f3";
        default:
          break;
      }
    } else {
      if (deadline >= 7) {
        return "#2e7d32";
      } else if (deadline <= 6) {
        return "#d50000";
      }
    }
  }
  const useStyles = makeStyles({
    DocumentContainerEnd: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
    },
  });
  const classes = useStyles();
  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Grid container spacing={1}>
            <Grid
              xs={6}
              sm={2}
              classes={{ root: classes.DocumentContainerEnd }}
            >
              <Box
                height="20px"
                width="20px"
                bgcolor="#ff9800"
                style={{ borderRadius: "50%" }}
              />
              <Typography>:待決策</Typography>
            </Grid>
            <Grid
              xs={6}
              sm={2}
              classes={{ root: classes.DocumentContainerEnd }}
            >
              <Box
                height="20px"
                width="20px"
                bgcolor="#ffeb3b"
                style={{ borderRadius: "50%" }}
              />
              <Typography>:還沒開始進行</Typography>
            </Grid>
            <Grid
              xs={6}
              sm={2}
              classes={{ root: classes.DocumentContainerEnd }}
            >
              <Box
                height="20px"
                width="20px"
                bgcolor="#2e7d32"
                style={{ borderRadius: "50%" }}
              />
              <Typography>:剩餘7天以上</Typography>
            </Grid>
            <Grid
              xs={6}
              sm={2}
              classes={{ root: classes.DocumentContainerEnd }}
            >
              <Box
                height="20px"
                width="20px"
                bgcolor="#d50000"
                style={{ borderRadius: "50%" }}
              />
              <Typography>:剩餘6天以下</Typography>
            </Grid>
            <Grid
              xs={6}
              sm={2}
              classes={{ root: classes.DocumentContainerEnd }}
            >
              <Box
                height="20px"
                width="20px"
                bgcolor="#2196f3"
                style={{ borderRadius: "50%" }}
              />
              <Typography>:已完成</Typography>
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <Table
            data={data ? data.personalMessages.contents : []}
            tableWidth={isPhone ? 3 : 2}
            header={[
              "屬性類別",
              "工作內容說明",
              "狀態燈號",
              "狀態更新時間",
              "最後更新者",
              "狀態說明",
            ]}
            columns={[
              (item) => item.category.name,
              "task",
              (item) => (
                <>
                  <Grid container justifyContent="center">
                    <Box
                      height="20px"
                      width="20px"
                      style={{ borderRadius: "50%" }}
                      bgcolor={getColor(item.shouldFinishAt, item.status)}
                    />
                  </Grid>
                </>
              ),
              (item) => moment(item.updatedAt).format("yyyy/MM/DD"),
              (item) => item.updatedBy.fullName,
              (item) => item.response,
            ]}
            onPress={() => {
              history.replace("/console/assignments");
            }}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                Boolean(data) && data.personalMessages.pageCount
                  ? data.personalMessages.pageCount
                  : 1
              }
              size="large"
              color="primary"
              page={newData.page}
              onChange={(e, n) => {
                changeData("page", n, true);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
